import rtlPlugin from 'stylis-plugin-rtl'
import {CacheProvider} from '@emotion/react'
import createCache from '@emotion/cache'
import {useIsRtl} from 'store/Store.js'

export function RTL(props) {
    const isRtl = useIsRtl()

    const cacheRtl = createCache({
        key: isRtl ? 'muirtl' : 'mui',
        stylisPlugins: isRtl ? [rtlPlugin] : [],
    })

    return <CacheProvider value={cacheRtl}>{props.children}</CacheProvider>
}
